import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

const CropOverview = ({ crop, onUpdate, viewMode }) => {
  const [slug, setSlug] = useState(crop.slug || '');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    try {
      await onUpdate({ slug: slug.trim() });
      setMessage('Saved.');
    } catch (err) {
      setMessage(err.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  if (viewMode) {
    return (
      <div className="card p-3">
        <div className="mb-0">
          <label className="form-label text-muted small">Slug</label>
          <p className="mb-0">{crop.slug || '—'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card p-3">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Slug</label>
          <input
            type="text"
            className="form-control"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
          />
        </div>
        {message && <div className="mb-2 text-small text-muted">{message}</div>}
        <Button type="submit" variant="primary" disabled={saving}>
          {saving ? 'Saving…' : 'Save'}
        </Button>
      </form>
    </div>
  );
};

export default CropOverview;
